// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__mKMjr","footer":"ChangeClinic_footer__1bGWk"};